<script setup>
import Modal from './Modal.vue';
const emit = defineEmits(['relogin']);
</script>
<template>
    <modal :allowClose="false">
        <template #header>
            <h3><Icon icon="fa6-solid:triangle-exclamation" /> Session expired</h3>
        </template>
        <template #body>
            <p>Your login session has expired. Please log in again to continue.</p>
        </template>
        <template #footer>
            <button class="button primary" @click="emit('relogin')">Log in again</button>
        </template>
    </modal>
</template>
